export { default as AcceptedCheck } from '@assets/icons/approval/accepted-check.svg';
export { default as Pending } from '@assets/icons/approval/pending.svg';
export { default as Rejected } from '@assets/icons/approval/rejected.svg';
